import React from 'react';
import { CapabilityStatement } from '../components/CapabilityStatement';
import { FileCheck, ShieldAlert, Award, Briefcase, ShieldCheck } from 'lucide-react';
import { PageWrapper, SectionWrapper } from '../components/MotionWrappers';
export function EntityData() {
  return <PageWrapper data-id="element-567">
      <div className="bg-white" data-id="element-568">
        <div className="bg-slate-50 py-16 border-b border-slate-200" data-id="element-569">
          <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-570">
            <h1 className="text-4xl md:text-5xl font-black text-federal-blue mb-4" data-id="element-571">
              Entity Data & Compliance
            </h1>
          </div>
        </div>
        <SectionWrapper data-id="element-572">
          <CapabilityStatement data-id="element-573" />
        </SectionWrapper>
        <section className="py-16 bg-white" data-id="element-574">
          <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-575">
            <div className="grid md:grid-cols-2 gap-16" data-id="element-576">
              <SectionWrapper data-id="element-577">
                <div data-id="element-578">
                  <h3 className="text-xl font-black text-federal-blue uppercase tracking-widest mb-8 flex items-center gap-2" data-id="element-579">
                    <Briefcase className="w-5 h-5 text-muted-gold" data-id="element-580" />
                    Contract Vehicles
                  </h3>
                  <div className="space-y-4" data-id="element-581">
                    {[{
                    name: 'GSA Multiple Award Schedule (MAS)',
                    code: 'GS-35F-XXXXX'
                  }, {
                    name: '8(a) STARS III (In Progress)',
                    code: 'Pending'
                  }, {
                    name: 'SeaPort-NxG',
                    code: 'N00178-XX-D-XXXX'
                  }].map((vehicle, i) => <div key={i} className="flex justify-between items-center p-4 bg-slate-50 border border-slate-200 rounded-sm transition-colors hover:border-federal-blue" data-id="element-582">
                        <span className="font-bold text-tech-slate text-sm" data-id="element-583">
                          {vehicle.name}
                        </span>
                        <span className="text-[10px] font-black bg-federal-blue text-white px-2 py-1 rounded uppercase" data-id="element-584">
                          {vehicle.code}
                        </span>
                      </div>)}
                  </div>
                </div>
              </SectionWrapper>
              <SectionWrapper delay={0.1} data-id="element-585">
                <div data-id="element-586">
                  <h3 className="text-xl font-black text-federal-blue uppercase tracking-widest mb-8 flex items-center gap-2" data-id="element-587">
                    <Award className="w-5 h-5 text-muted-gold" data-id="element-588" />
                    Quality Assurance
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-589">
                    {[{
                    Icon: FileCheck,
                    label: 'ISO 9001:2015'
                  }, {
                    Icon: ShieldAlert,
                    label: 'ISO 27001'
                  }, {
                    Icon: ShieldCheck,
                    label: 'CMMI Level 3'
                  }, {
                    Icon: Award,
                    label: 'NIST 800-171'
                  }].map(item => <div key={item.label} className="p-4 border border-slate-200 rounded-sm text-center transition-colors hover:border-federal-blue" data-id="element-590">
                        <item.Icon className="w-8 h-8 text-federal-blue mx-auto mb-2" data-id="element-591" />
                        <p className="text-[10px] font-black uppercase text-tech-slate" data-id="element-592">
                          {item.label}
                        </p>
                      </div>)}
                  </div>
                </div>
              </SectionWrapper>
            </div>
          </div>
        </section>
      </div>
    </PageWrapper>;
}